import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/annuity-payment-calculator',
  component: () => import('../../routes/AnnuityPayment.svelte'),
  card: {
    id: 'annuity-payment-calculator',
    title: 'Annuity Payment Calculator',
    description: 'Find the payment amount for an annuity given PV, rate, and periods — or solve for PV, FV, rate, or time.',
    icon: 'payments',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/annuity-payment-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Annuity Payment Calculator – Solve for Payment, PV, FV, Rate, or Periods',
    description: 'Calculate annuity payments, present value, or future value. Supports monthly, quarterly, annual, biweekly, and weekly payment frequencies. Find the payment needed to fund a retirement annuity.',
  },
};

export default meta;